var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"stylist-actions"},_vm._l((_vm.stylistActions),function(stylistAction,key){return _c('div',{key:stylistAction.key,staticClass:"stylist-action",on:{"click":function($event){return _vm.goToAction(stylistAction)}}},[_c('i',{class:stylistAction.icon}),_c('p',[_vm._v(_vm._s(key))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }